import { render } from "./AlarmReminderEdit.vue?vue&type=template&id=5c991d4e"
import script from "./AlarmReminderEdit.vue?vue&type=script&lang=js"
export * from "./AlarmReminderEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__